import React from "react";
import { Row, Col, Tag, Table, Card, Button } from "antd";
import moment from "moment";
import { useLocation } from "react-router-dom";

// TODO: Reformat this code:ganti nama folder, pindahkan/hapus dummy data
const DetailUndangan2 = () => {
  //   const data = {
  //     meetingId: 1,
  //     meetingName: "Meeting 1",
  //     location: "Serang",
  //     date: "2025-05-01T10:00:00.000Z",
  //     users: [
  //       {
  //         userId: 1,
  //         name: "Faiz",
  //         role: "Dewan",
  //         confirmAt: "2025-05-01T08:30:00.000Z",
  //         checkedInAt: "2025-05-01T09:55:00.000Z",
  //       },
  //       {
  //         userId: 2,
  //         name: "Ahmad",
  //         role: "Dewan",
  //         confirmAt: "2025-05-01T07:00:00.000Z",
  //         checkedInAt: null,
  //       },
  //       {
  //         userId: 3,
  //         name: "Rina",
  //         role: "Dewan",
  //         confirmAt: null,
  //         checkedInAt: null,
  //       },
  //       {
  //         userId: 4,
  //         name: "Ghazi",
  //         role: "Dewan",
  //         confirmAt: null,
  //         checkedInAt: "2025-05-01T07:00:00.000Z",
  //       },
  //     ],
  //   };

  const location = useLocation();
  const data = location.state;

  if (!data) {
    return <p>Tidak ada data undangan.</p>;
  }

  console.log("d2:", data);

  const getAttendanceStatus = (record) => {
    if (record.checkedInAt) {
      return { label: "Sudah Datang", color: "green" };
    }
    if (record.confirmAt) {
      return { label: "Akan Datang", color: "orange" };
    }
    return { label: "Belum Konfirmasi", color: "gray" };
  };

  const tableColumns = [
    {
      title: "Id",
      dataIndex: "userId",
      key: "userId",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Tanggal Konfirmasi",
      dataIndex: "confirmAt",
      key: "confirmAt",
      render: (_, record) => {
        return record.confirmAt
          ? moment(record.confirmAt).format("YYYY-MM-DD")
          : "-";
      },
    },
    {
      title: "Waktu Konfirmasi",
      dataIndex: "confirmAt",
      key: "confirmAt",
      render: (_, record) => {
        return record.confirmAt
          ? moment(record.confirmAt).format("HH:mm")
          : "-";
      },
    },
    {
      title: "Tanggal Datang",
      dataIndex: "checkedInAt",
      key: "checkedInAt",
      render: (_, record) => {
        return record.checkedInAt
          ? moment(record.checkedInAt).format("YYYY-MM-DD")
          : "-";
      },
    },
    {
      title: "Waktu Datang",
      dataIndex: "checkedInAt",
      key: "checkedInAt",
      render: (_, record) => {
        return record.checkedInAt
          ? moment(record.checkedInAt).format("HH:mm")
          : "-";
      },
    },
    {
      title: "Status",
      key: "status",
      render: (_, record) => {
        const status = getAttendanceStatus(record);
        return <Tag color={status.color}>{status.label}</Tag>;
      },
    },
    // {
    //   title: () => <div className="text-center">Detail</div>,
    //   key: "detail",
    //   render: (_, record) => (
    //     <div className="text-center">
    //       <Button
    //         type="primary"
    //         style={{ textAlign: "center" }}
    //         // onClick={() => {
    //         //   history.push({
    //         //     pathname: `${strings.navigation.path.detail_undangan2}`,
    //         //     state: record,
    //         //   });
    //         // }}
    //       >
    //         Detail
    //       </Button>
    //     </div>
    //   ),
    // },
    {
      title: () => <div className="text-center">Action</div>,
      key: "status",
      render: (_, record) => (
        <div className="text-center">
          <Button
            type="danger"
            style={{ textAlign: "center", color: "white" }}
            // onClick={() => {
            //   confirm(record.id);
            // }}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  // Prepare data for the table
  const tableDataUser = (data.users || []).map((user) => ({
    userId: user.id,
    name: user.name || `User ${user.user_id}`,
    role: user.role || "-",
    confirmAt: user.confirm_at,
    checkedInAt: user.checked_in_at,
  }));

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>{data.meetingName}</h2>
          <p>
            <strong>Tanggal:</strong>{" "}
            {moment(data.date).format("dddd, DD MMMM YYYY")}
          </p>
          <p>
            <strong>Waktu:</strong> {moment(data.date).format("HH:mm")}
          </p>
          <p>
            <strong>Lokasi:</strong> {data.location}
          </p>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <Row gutter={24}>
              <Table
                className="no-border-last"
                style={{ textAlign: "center", margin: "auto" }}
                scroll={{ x: "100%" }}
                columns={tableColumns}
                dataSource={tableDataUser}
                rowKey="id"
                // loading={isLoading}
                // pagination={{
                //   defaultPageSize: 10,
                //   defaultCurrent: metaData.page,
                //   total: metaData.total_data,
                // }}
                // onChange={handleTableChange}
              />
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DetailUndangan2;
